export default class AllowanceDetailActions {

  static NEW_DATA = 'NEW_DATA';
  static UPDATE_DATA='UPDATE_DATA';
  static SHOW_DATA='SHOW_DATA';
  static VIEW_DATA='VIEW_DATA';
  static DELETE_DATA='DELETE_DATA';
  static ON_SUBMIT='ON_SUBMIT';
  static ERROR_DATA='ERROR_DATA';
  static PROCESS_DATA='PROCESS_DATA';
  static RESET_DATA='RESET_DATA';
  static GET_HELPER_ALLOWANCEDETAIL='GET_HELPER_ALLOWANCEDETAIL';
  static SUCCESS_DATA='SUCCESS_DATA';
  static ERROR_SERVER='ERROR_SERVER';
  static RESET_LIST='RESET_LIST';
  static submit(){
    return {
      type: AllowanceDetailActions.ON_SUBMIT
    };
  }

  static create(data) {
    return {
      type: AllowanceDetailActions.NEW_DATA,
      payload: data
    };
  }

  static update(data) {
    return {
      type: AllowanceDetailActions.UPDATE_DATA,
      payload: data
    };
  }

  static view(data) {
    return {
      type: AllowanceDetailActions.VIEW_DATA,
      payload: data
    };
  }

  static delete(data) {
    return {
      type: AllowanceDetailActions.DELETE_DATA
    };
  }

  static list(data) {
    return {
      type: AllowanceDetailActions.SHOW_DATA,
      payload: data
    };
  }
  static resetList() {
    return {
      type: AllowanceDetailActions.RESET_LIST
    };
  }
  static error(error){
    return {
      type: AllowanceDetailActions.ERROR_DATA,
      payload: error
    };
  }
  static success(){
    return {
      type: AllowanceDetailActions.SUCCESS_DATA,
    };
  }
  static process(){
    return {
      type: AllowanceDetailActions.PROCESS_DATA,
    };
  }
  static reset(){
    return {
      type: AllowanceDetailActions.RESET_DATA,
    };
  }
  static helper(data){
    return {
      type: AllowanceDetailActions.GET_HELPER_ALLOWANCEDETAIL,
      payload:data
    };
  }
  static errorInternal(error){
    return {
      type: AllowanceDetailActions.ERROR_SERVER,
      payload: error
    };
  }
}